/// <amd-module name="SuiteCommerce.Blog.Pagination.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Pagination.Configuration", ["require", "exports", "SuiteCommerce.Blog.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PaginationConfiguration = void 0;
    var PaginationConfiguration = /** @class */ (function (_super) {
        __extends(PaginationConfiguration, _super);
        function PaginationConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(PaginationConfiguration, "paginationLabel", {
            get: function () {
                return this.get('blog.paginationLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PaginationConfiguration, "articlesByPage", {
            get: function () {
                return parseInt(this.get('blog.articlesByPage'), 10);
            },
            enumerable: false,
            configurable: true
        });
        return PaginationConfiguration;
    }(Configuration_1.Configuration));
    exports.PaginationConfiguration = PaginationConfiguration;
});
